export const DEFAULT_FEATURE_FLAGS = [
  'fe_favorite_property',
  'fe_property_views',
  'fe_ui_docs',
  'fe_buy_boxes',
  'fe_sell_features',
];
